export class Product {
    constructor(id: number, name: string, price: number, originalPrice: number, foreignPrice: number, quantity: number, subProductIdentifier: number, timeSlotGroupKeys: number[], listElement: HTMLElement, min?: number, max?: number) {
        this.Id = id;
        this.Name = name;
        this.Price = price;
        this.OriginalPrice = originalPrice;
        this.ForeignPrice = foreignPrice;
        this.Quantity = quantity;
        this.SubProductIdentifier = subProductIdentifier;
        this.ListElement = listElement;
        this.TimeSlotGroupKeys = timeSlotGroupKeys;

        this.Min = min;
        this.Max = max;
    }

    Id: number;
    Name: string;
    Price: number;
    OriginalPrice: number;
    ForeignPrice: number;
    Quantity: number;

    //PersonType, PackagePosNr
    SubProductIdentifier: number;

    Min?: number;
    Max?: number;
    Sort?: number;

    TimeSlotGroupKeys: number[];

    ListElement: HTMLElement;
}